import React, { useRef, useState } from 'react';
import styles from './AddBrandInformation.module.scss';
import BackButton from '../../../common/BackButton/BackButton';
import { Container, Row, Col, Input, Label, Button, Form, FormGroup } from 'reactstrap';
import UploadMedia from '../../../common/UploadMedia/UploadMedia';
import { useLocation } from 'react-router-dom';
import { GoCheckCircleFill } from "react-icons/go";

const AddBrandInformation = () => {
    const location = useLocation();
    const { isBrandEdit } = location.state || {};

    const [businessLicense, setBusinessLicense] = useState('');
    const [trademark, setTrademark] = useState('');
    const [otherDocuments, setOtherDocuments] = useState('');
    const [agreementDocuments, setAgreementDocuments] = useState('');
    const [relationshipType, setRelationshipType] = useState({
        owner: false,
        authorizedReseller: false,
        exclusivePartner: false,
        officialDistributor: false,
        other: false,
        otherText: ''
    });

    const highlightProductFileInputRef = useRef(null);
    const marketingMaterialFileInputRef = useRef(null);

    const [highlightProductImages, setHighlightProductImages] = useState([]);
    const [marketingMediaFiles, setMarketingMediaFiles] = useState([]);
    const [showApproval, setShowApproval] = useState(false);

    const handleSubmitForApproval = () => {
        setShowApproval(true);
    };

    // Handlers for file input changes
    const handleFileChange = (e, setDocument) => {
        const file = e.target.files[0];
        if (file) {
            setDocument(file.name);  // Set the file name as the state
        }
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setRelationshipType((prevState) => ({
            ...prevState,
            [name]: checked,
        }));
    };

    const handleOtherTextChange = (e) => {
        setRelationshipType((prevState) => ({
            ...prevState,
            otherText: e.target.value,
        }));
    };

    return (
        <div className={styles.mainContainer}>
            {isBrandEdit && <BackButton />}

            {showApproval ? (
                <Container fluid className={styles.registeredContainer}>
                    <Row className={styles.registeredRow}>
                        <Col className="text-center p-0">
                            <div className={styles.checkIcon}>
                                <GoCheckCircleFill size={140} color="#EC7426" />
                            </div>
                            <h5 className={styles.registeredMessage}>
                                Brand Registry form is successfully submitted
                            </h5>
                            <p>Approval Process will take 4-5 days</p>
                        </Col>
                    </Row>
                </Container>
            ) : (
                <div className={styles.addEditBrandContainer}>
                    <h4 className={styles.sectionHeading}>
                        {isBrandEdit ? "Edit Brand Information" : "Add New Brand"}
                    </h4>

                    <Container fluid className={styles.addEditBrandSection}>
                        <div className={styles.sectionTitle}>
                            <h5 className={styles.sectionSubHeading}>Basic Information</h5>
                        </div>

                        {/* Basic Information Section */}
                        <Row className={styles.brandFormRow}>
                            <Form className={styles.formSection}>
                                <FormGroup>
                                    <Row className={styles.formGroupRow}>
                                        <Col lg={3} xl={2}>
                                            <Label for="brandName">Brand Name:</Label>
                                        </Col>
                                        <Col lg={5} xl={4}>
                                            <Input type="text" id="brandName" placeholder="Enter Brand Name" />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row className={styles.formGroupRow}>
                                        <Col lg={3} xl={2}>
                                            <Label for="category">Category:</Label>
                                        </Col>
                                        <Col lg={5} xl={4}>
                                            <Input type="select" id="category">
                                                <option>Choose from dropdown menu</option>
                                                <option>Choose from dropdown menu</option>
                                                <option>Choose from dropdown menu</option>
                                            </Input>
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row className={styles.formGroupRow}>
                                        <Col lg={3} xl={2}>
                                            <Label for="brandWebsite">Brand Website:</Label>
                                        </Col>
                                        <Col lg={5} xl={4}>
                                            <Input type="text" id="brandWebsite" placeholder="Enter Brand Website" />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row className={styles.formGroupRow}>
                                        <Col lg={3} xl={2}>
                                            <Label for="brandDescription">Brand Description:</Label>
                                        </Col>
                                        <Col lg={9} xl={10}>
                                            <Input type="textarea" id="brandDescription" placeholder="Enter Brand Description" />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Form>
                        </Row>

                        <div className={styles.sectionTitle}>
                            <h5 className={styles.sectionSubHeading}>Brand Documentation</h5>
                        </div>

                        {/* Brand Documentation Section */}
                        <Row className={styles.brandFormRow}>
                            <Form className={styles.formSection}>
                                <FormGroup>
                                    <Row className={styles.formGroupRow}>
                                        <Col xl={3} xxl={2}>
                                            <Label for="businessLicense">Business License:</Label>
                                        </Col>
                                        <Col xl={9} xxl={10}>
                                            <div className={styles.uploadDocumentContainer}>
                                                <Input type="file" id="businessLicense" onChange={(e) => handleFileChange(e, setBusinessLicense)} hidden />
                                                <Button color="info" className={styles.uploadDocumentButton} onClick={() => document.getElementById('businessLicense').click()}>Add Document</Button>
                                                <span className={styles.uploadedFileName}>{businessLicense || 'No document uploaded'}</span>
                                            </div>
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row className={styles.formGroupRow}>
                                        <Col xl={3} xxl={2}>
                                            <Label for="trademark">Trademark Registration:</Label>
                                        </Col>
                                        <Col xl={9} xxl={10}>
                                            <Input type="text" id="trademark" placeholder="Enter trademark number" />
                                        </Col>
                                    </Row>
                                    <Row className={styles.formGroupRow}>
                                        <Col xl={{ offset: 3, size: 9 }} xxl={{ offset: 2, size: 10 }}>
                                            <div className={styles.uploadDocumentContainer}>
                                                <Input type="file" id="trademarkDocument" onChange={(e) => handleFileChange(e, setTrademark)} hidden />
                                                <Button color="info" className={styles.uploadDocumentButton} onClick={() => document.getElementById('trademarkDocument').click()}>Add Document</Button>
                                                <span className={styles.uploadedFileName}>{trademark || 'No document uploaded'}</span>
                                            </div>
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row className={styles.formGroupRow}>
                                        <Col xl={3} xxl={2}>
                                            <Label for="otherDocuments">Other Relevant Documents:</Label>
                                        </Col>
                                        <Col xl={9} xxl={10}>
                                            <div className={styles.uploadDocumentContainer}>
                                                <Input type="file" id="otherDocuments" onChange={(e) => handleFileChange(e, setOtherDocuments)} hidden />
                                                <Button color="info" className={styles.uploadDocumentButton} onClick={() => document.getElementById('otherDocuments').click()}>Add Document</Button>
                                                <span className={styles.uploadedFileName}>{otherDocuments || 'No document uploaded'}</span>
                                            </div>
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Form>
                        </Row>

                        <div className={styles.sectionTitle}>
                            <h5 className={styles.sectionSubHeading}>Basic Relationship</h5>
                        </div>

                        {/* Basic Relationship Section */}
                        <Row className={styles.relationshipFormRow}>
                            <Form className={styles.formSection}>
                                <FormGroup>
                                    <Row className={styles.formGroupRow}>
                                        <Col xl={3} xxl={2}>
                                            <Label>Relationship type:</Label>
                                        </Col>
                                        <Col xl={9} xxl={10}>
                                            <div className={styles.checkboxGroup}>
                                                <Label check>
                                                    Owner
                                                    <Input
                                                        type="checkbox"
                                                        name="owner"
                                                        className={styles.checkBox}
                                                        checked={relationshipType.owner}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                </Label>
                                                <Label check>
                                                    Authorized Reseller
                                                    <Input
                                                        type="checkbox"
                                                        name="authorizedReseller"
                                                        className={styles.checkBox}
                                                        checked={relationshipType.authorizedReseller}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                </Label>
                                                <Label check>
                                                    Exclusive Partner
                                                    <Input
                                                        type="checkbox"
                                                        name="exclusivePartner"
                                                        className={styles.checkBox}
                                                        checked={relationshipType.exclusivePartner}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                </Label>
                                                <Label check>
                                                    Official Distributor
                                                    <Input
                                                        type="checkbox"
                                                        name="officialDistributor"
                                                        className={styles.checkBox}
                                                        checked={relationshipType.officialDistributor}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                </Label>
                                                <Label check>
                                                    Other
                                                    <Input
                                                        type="checkbox"
                                                        name="other"
                                                        className={styles.checkBox}
                                                        checked={relationshipType.other}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                </Label>
                                            </div>
                                        </Col>
                                    </Row>
                                    {relationshipType.other && (
                                        <Row className={styles.formGroupRow}>
                                            <Col lg={6} xl={{ offset: 3, size: 5 }} xxl={{ offset: 2, size: 4 }}>
                                                <div>
                                                    <Label for="otherInput">In case of other</Label>
                                                    <Input
                                                        type="text"
                                                        id="otherInput"
                                                        className={styles.otherInput}
                                                        placeholder="Relation with brand"
                                                        value={relationshipType.otherText}
                                                        onChange={handleOtherTextChange}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                </FormGroup>
                                <FormGroup>
                                    <Row className={styles.formGroupRow}>
                                        <Col xl={3} xxl={2}>
                                            <Label for="agreementDocuments">Agreement Documents:</Label>
                                        </Col>
                                        <Col xl={9} xxl={10}>
                                            <div className={styles.uploadDocumentContainer}>
                                                <Input type="file" id="agreementDocuments" onChange={(e) => handleFileChange(e, setAgreementDocuments)} hidden />
                                                <Button color="info" className={styles.uploadDocumentButton} onClick={() => document.getElementById('agreementDocuments').click()}>Add Document</Button>
                                                <span className={styles.uploadedFileName}>{agreementDocuments || 'No document uploaded'}</span>
                                            </div>
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row className={styles.formGroupRow}>
                                        <Col xl={3} xxl={2}>
                                            <Label for="contactPerson">Contact Person at Brand:</Label>
                                        </Col>
                                        <Col xl={5} xxl={4}>
                                            <Input type="text" id="contactPerson" placeholder="Enter Contact Person at Brand" className={styles.input} />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row className={styles.formGroupRow}>
                                        <Col xl={3} xxl={2}>
                                            <Label for="contactEmail">Contact Email:</Label>
                                        </Col>
                                        <Col xl={5} xxl={4}>
                                            <Input type="text" id="contactEmail" placeholder="Enter Contact Email" className={styles.input} />
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row className={styles.formGroupRow}>
                                        <Col xl={3} xxl={2}>
                                            <Label for="contactPhone">Contact Phone:</Label>
                                        </Col>
                                        <Col xl={5} xxl={4}>
                                            <Input type="text" id="contactPhone" placeholder="Enter Contact Phone" className={styles.input} />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Form>
                        </Row>

                        <div className={styles.sectionTitle}>
                            <h5 className={styles.sectionSubHeading}>Verification and Approval</h5>
                        </div>

                        {/* Verification and Approval Section */}
                        <Row className={styles.brandFormRow}>
                            <Form className={styles.formSection}>
                                <FormGroup>
                                    <Row className={styles.formGroupRow}>
                                        <Col xl={3} xxl={2}>
                                            <Label for="status">Status:</Label>
                                        </Col>
                                        <Col xl={9} xxl={10}>
                                            <p className={styles.verficationApprovalText}>Pending/Approved</p>
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row className={styles.formGroupRow}>
                                        <Col xl={3} xxl={2}>
                                            <Label for="approvalTime">Estimated Approval Time:</Label>
                                        </Col>
                                        <Col xl={9} xxl={10}>
                                            <p className={styles.verficationApprovalText}>5 days</p>
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row className={styles.formGroupRow}>
                                        <Col xl={3} xxl={2}>
                                            <Label for="contactSupport">Contact Support:</Label>
                                        </Col>
                                        <Col xl={9} xxl={10}>
                                            <p className={styles.verficationApprovalText}>Link</p>
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Form>
                        </Row>

                        <div className={styles.sectionTitle}>
                            <h5 className={styles.sectionSubHeading}>Brand Customization</h5>
                        </div>

                        {/* Brand Customization Section */}
                        <div className={styles.infoFormWrapper}>
                            <Row className={styles.brandFormRow}>
                                <Form className={styles.formSection}>
                                    <FormGroup>
                                        <Row className={styles.formGroupRow}>
                                            <Col xl={3} xxl={2}>
                                                <Label for="brandStory">Brand Story:</Label>
                                            </Col>
                                            <Col xl={9} xxl={10}>
                                                <Input type="textarea" id="brandStory" placeholder="Enter Brand Story" />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup>
                                        <Row className={styles.formGroupRow}>
                                            <Col xl={3} xxl={2}>
                                                <Label>Highlight Products:</Label>
                                            </Col>
                                            <Col xl={9} xxl={10}>
                                                <div className={styles.uploadDocumentContainer}>
                                                    <Button
                                                        color="info"
                                                        className={styles.uploadDocumentButton}
                                                        onClick={() => highlightProductFileInputRef.current && highlightProductFileInputRef.current.click()} // Trigger file input on button click
                                                    >
                                                        Add Products
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className={styles.formGroupRow}>
                                            <Col xl={{ offset: 3, size: 9 }} xxl={{ offset: 2, size: 10 }}>
                                                <UploadMedia
                                                    pictures={highlightProductImages}
                                                    setPictures={setHighlightProductImages}
                                                    maxMedia={6}
                                                    allowImages={true}
                                                    allowVideos={true}
                                                    fileInputRef={highlightProductFileInputRef}
                                                    hideUploadLabel={true}
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup>
                                        <Row className={styles.formGroupRow}>
                                            <Col xl={3} xxl={2}>
                                                <Label>Marketing Materials:</Label>
                                            </Col>
                                            <Col xl={9} xxl={10}>
                                                <div className={styles.uploadDocumentContainer}>
                                                    <Button
                                                        color="info"
                                                        className={styles.uploadDocumentButton}
                                                        onClick={() => marketingMaterialFileInputRef.current && marketingMaterialFileInputRef.current.click()} // Trigger file input on button click
                                                    >
                                                        Add
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className={styles.formGroupRow}>
                                            <Col xl={{ offset: 3, size: 9 }} xxl={{ offset: 2, size: 10 }}>
                                                <UploadMedia
                                                    pictures={marketingMediaFiles}
                                                    setPictures={setMarketingMediaFiles}
                                                    maxMedia={6}
                                                    allowImages={true}
                                                    allowVideos={true}
                                                    fileInputRef={marketingMaterialFileInputRef}
                                                    hideUploadLabel={true}
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </Form>
                            </Row>
                        </div>
                    </Container>

                    <Container fluid className={styles.actionBtnContainer}>
                        <Button type="submit" color="primary" onClick={handleSubmitForApproval}>Submit for Approval</Button>
                    </Container>
                </div>
            )}
        </div>
    )
}

export default AddBrandInformation;